module.exports = __webpack_public_path__ + "static/media/Micro-logiciel.ee8df4ec.jpg";